// ============================================
// UPDATED: /frontend/src/routes/AppRoutes.jsx
// Added Edit Listing route
// ============================================

import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import AdminRoute from './AdminRoute';
import AdminSidebar from '../components/layout/AdminSidebar';

// Public Pages
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import AboutPage from '../pages/AboutPage';
import ContactPage from '../pages/ContactPage';
import PrivacyPage from '../pages/PrivacyPage';
import TermsPage from '../pages/TermsPage';
import VehiclesPage from '../pages/VehiclesPage';
import PropertiesPage from '../pages/PropertiesPage';
import CarDealersPage from '../pages/CarDealersPage';
import RealEstateAgentsPage from '../pages/RealEstateAgentsPage';
import AgentsPage from '../pages/AgentsPage';
import SearchPage from '../pages/SearchPage';
import ListingDetailPage from '../pages/ListingDetailPage';
import SubmitJVPage from '../pages/SubmitJVPage';
import AgentDetailPage from '../pages/AgentDetailPage';
import FinanceApplicationPage from '../pages/FinanceApplicationPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';

// Protected Pages
import MyListingsPage from '../pages/MyListingsPage';
import CreateListingPage from '../pages/CreateListingPage';
import EditListingPage from '../pages/EditListingPage'; // ⭐ NEW
import CheckoutPage from '../pages/CheckoutPage';
import PaymentPage from '../pages/PaymentPage';
import MyInquiriesPage from '../pages/MyInquiriesPage';
import ReceivedInquiriesPage from '../pages/ReceivedInquiriesPage';
import JVCheckoutPage from '../pages/JVCheckoutPage';
import MySubmissionPage from '../pages/MySubmissionPage';
import ConnectionChatPage from '../pages/ConnectionChatPage';
import UserConnectionsPage from '../pages/UserConnectionsPage'; // ⭐ NEW
import WhatsAppToolsPage from '../pages/WhatsAppToolsPage';
import WhatsAppAnalyticsPage from '../pages/WhatsAppAnalyticsPage';
import FacebookToolsPage from '../pages/FacebookToolsPage';
import FacebookAnalyticsPage from '../pages/FacebookAnalyticsPage';
import SavedListingsPage from '../pages/SavedListingsPage';
import CompareListingsPage from '../pages/CompareListingsPage';
import MyPriceAlertsPage from '../pages/MyPriceAlertsPage';
import MyChamaInterestsPage from '../pages/MyChamaInterestsPage';


// Dashboard Pages
import UserDashboard from '../pages/UserDashboard';
import SettingsPage from '../pages/SettingsPage';
import UpgradePlanPage from '../pages/UpgradePlanPage';
import SubscriptionHistoryPage from '../pages/SubscriptionHistoryPage';

// Subscription Upgrade Pages
import SubscriptionCheckoutPage from '../pages/SubscriptionCheckoutPage';
import PaymentStatusPage from '../pages/PaymentStatusPage';
import PromoteCheckoutPage from '../pages/PromoteCheckoutPage'

// Admin Pages
import AdminDashboard from '../pages/admin/AdminDashboard';
import AnalyticsPage from '../pages/admin/AnalyticsPage';
import ContactsPage from '../pages/admin/ContactsPage';
import ContentPage from '../pages/admin/ContentPage';
import DataCenterPage from '../pages/admin/DataCenterPage';
import InquiriesPage from '../pages/admin/InquiriesPage';
import JointVenturesPage from '../pages/admin/JointVenturesAdminPage';
import ListingsPage from '../pages/admin/ListingsAdminPage';
import MarketingPage from '../pages/admin/MarketingPage';
import PaymentsPage from '../pages/admin/PaymentsPage';
import AdminSettingsPage from '../pages/admin/SettingsPage';
import SuperAdminPage from '../pages/admin/SuperAdminPage';
import AdminMatchesPage from '../pages/admin/AdminMatchesPage';
import AdminConnectionsPage from '../pages/admin/AdminConnectionsPage';
import FinanceApplicationsAdminPage from '../pages/admin/FinanceApplicationsAdminPage';
import SubscriptionsPage from '../pages/admin/SubscriptionsPage';
import SocialMediaCampaignsPage from '../pages/admin/SocialMediaCampaignsPage';

function AppRoutes() {
  console.log('[AppRoutes] 🗺️ Initializing routes');

  return (
    <Routes>
      {/* ============================================ */}
      {/* PUBLIC ROUTES */}
      {/* ============================================ */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/vehicles" element={<VehiclesPage />} />
      <Route path="/properties" element={<PropertiesPage />} />
      <Route path="/car-dealers" element={<CarDealersPage />} />
      <Route path="/real-estate-agents" element={<RealEstateAgentsPage />} />
      <Route path="/agents" element={<AgentsPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/listing/:id" element={<ListingDetailPage />} />
      <Route path="/joint-ventures" element={<SubmitJVPage />} />
      <Route path="/agent/:id" element={<AgentDetailPage />} />
      <Route path="/finance-application" element={<FinanceApplicationPage />} />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - Listings */}
      {/* ============================================ */}
      <Route
        path="/my-listings"
        element={
          <PrivateRoute>
            <MyListingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/listings/create"
        element={
          <PrivateRoute>
            <CreateListingPage />
          </PrivateRoute>
        }
      />
      
      {/* ⭐ NEW: Edit Listing Route */}
      <Route
        path="/listings/edit/:id"
        element={
          <PrivateRoute>
            <EditListingPage />
          </PrivateRoute>
        }
      />
      
      <Route
        path="/listings/checkout"
        element={
          <PrivateRoute>
            <CheckoutPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/listings/payment"
        element={
          <PrivateRoute>
            <PaymentPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/promote/checkout"
        element={
          <PrivateRoute>
            <PromoteCheckoutPage />
          </PrivateRoute>
        }
      />

      {/* NEW DISCOVERY FEATURES */}
      <Route
        path="/saved-listings"
        element={
          <PrivateRoute>
            <SavedListingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/compare"
        element={
          <PrivateRoute>
            <CompareListingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/my-price-alerts"
        element={
          <PrivateRoute>
            <MyPriceAlertsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/my-chama-interests"
        element={
          <PrivateRoute>
            <MyChamaInterestsPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - whatsapp routes */}
      {/* ============================================ */}

      <Route
        path="/dashboard/whatsapp-tools"
        element={
          <PrivateRoute>
            <WhatsAppToolsPage />
          </PrivateRoute>
        }
      />
      
      <Route
        path="/dashboard/whatsapp-analytics"
        element={
          <PrivateRoute>
            <WhatsAppAnalyticsPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - Facebook routes */}
      {/* ============================================ */}

      <Route
        path="/dashboard/facebook-tools"
        element={
          <PrivateRoute>
            <FacebookToolsPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/dashboard/facebook-analytics"
        element={
          <PrivateRoute>
            <FacebookAnalyticsPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - Joint Ventures */}
      {/* ============================================ */}
      <Route
        path="/jv/checkout"
        element={
          <PrivateRoute>
            <JVCheckoutPage />
          </PrivateRoute>
        }
      />
      
      <Route
        path="/jv/my-submission"
        element={
          <PrivateRoute>
            <MySubmissionPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - Connections & Messaging */}
      {/* ⭐ NEW: User Connections List */}
      {/* ============================================ */}
      <Route
        path="/my-connections"
        element={
          <PrivateRoute>
            <UserConnectionsPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/connections/:connectionId/chat"
        element={
          <PrivateRoute>
            <ConnectionChatPage />
          </PrivateRoute>
        }
      />
      
      {/* ============================================ */}
      {/* PROTECTED ROUTES - Inquiries */}
      {/* ============================================ */}
      <Route
        path="/my-inquiries"
        element={
          <PrivateRoute>
            <MyInquiriesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/received-inquiries"
        element={
          <PrivateRoute>
            <ReceivedInquiriesPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* PROTECTED ROUTES - User Dashboard */}
      {/* ============================================ */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <UserDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/settings"
        element={
          <PrivateRoute>
            <SettingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/upgrade"
        element={
          <PrivateRoute>
            <UpgradePlanPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/subscription-history"
        element={
          <PrivateRoute>
            <SubscriptionHistoryPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* SUBSCRIPTION UPGRADE ROUTES */}
      {/* ============================================ */}
      <Route
        path="/subscription/upgrade"
        element={
          <PrivateRoute>
            <UpgradePlanPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscription/checkout"
        element={
          <PrivateRoute>
            <SubscriptionCheckoutPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscription/payment-status"
        element={
          <PrivateRoute>
            <PaymentStatusPage />
          </PrivateRoute>
        }
      />

      {/* ============================================ */}
      {/* ADMIN ROUTES - Wrapped with AdminSidebar */}
      {/* ============================================ */}
      <Route
        path="/admin/*"
        element={
          <AdminRoute>
            <AdminSidebar>
              <Routes>
                <Route path="/" element={<AdminDashboard />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/content" element={<ContentPage />} />
                <Route path="/data-center" element={<DataCenterPage />} />
                <Route path="/inquiries" element={<InquiriesPage />} />
                <Route path="/joint-ventures" element={<JointVenturesPage />} />
                <Route path="/listings" element={<ListingsPage />} />
                <Route path="/marketing" element={<MarketingPage />} />
                <Route path="/payments" element={<PaymentsPage />} />
                <Route path="/settings" element={<AdminSettingsPage />} />
                <Route path="/super-admin" element={<SuperAdminPage />} />
                <Route path="/matches" element={<AdminMatchesPage />} />
                <Route path="/connections" element={<AdminConnectionsPage />} />
                <Route path="/finance-applications" element={<FinanceApplicationsAdminPage />} />
                <Route path="/subscriptions" element={<SubscriptionsPage />} />
                <Route path="/social-campaigns" element={<SocialMediaCampaignsPage />} />
              </Routes>
            </AdminSidebar>
          </AdminRoute>
        }
      />

      {/* ============================================ */}
      {/* 404 ROUTE */}
      {/* ============================================ */}
      <Route 
        path="*" 
        element={
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">
              <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
              <p className="text-muted-foreground mb-4">The page you're looking for doesn't exist.</p>
              <a href="/" className="text-primary underline hover:no-underline">
                Return to Home
              </a>
            </div>
          </div>
        } 
      />
    </Routes>
  );
}

export default AppRoutes;